import { useEffect } from "react";
import { useScript } from "usehooks-ts";
import { getCurrentGateway, getGatewayConfig } from "./config";
import type { PaymentGateway } from "./types";

/**
 * Custom hook to load payment gateway scripts
 * Handles gateways with or without external script dependencies
 *
 * @returns Object containing gateway info and script loading status
 */
export function useGatewayScript() {
  const paymentGateway = getCurrentGateway();
  const gatewayConfig = getGatewayConfig(paymentGateway);

  // Only load script if scriptUrl is configured for the gateway
  const scriptStatus = useScript(gatewayConfig.scriptUrl || "");

  // If no script URL is configured, treat it as "ready" (gateway doesn't need external script)
  const status = gatewayConfig.scriptUrl === null ? "ready" : scriptStatus;

  useEffect(() => {
    if (status === "error" && gatewayConfig.scriptUrl) {
      console.error(
        `Payment gateway script failed to load: ${gatewayConfig.scriptUrl}`,
        {
          gateway: paymentGateway,
          gatewayName: gatewayConfig.name,
        }
      );
    }
  }, [status, gatewayConfig.scriptUrl, gatewayConfig.name, paymentGateway]);

  return {
    paymentGateway,
    gatewayConfig,
    status,
  };
}
